import React from 'react';
import {format} from "date-fns";
import {makeStyles, createStyles} from "@mui/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      margin:'12px 0',
      borderBottom: '1px solid #d2d2d2',
      padding: '8px',
      fontSize:15
    }
  })
);

export default function DayHeading({date}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {format(date, 'iii, do LLL')}
    </div>
  );
}
